import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionDepositAndStakeComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionDepositAndStake"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <path d="M7 9.33325L7 4.66659" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.66671 7L7.00004 4.66667L9.33337 7" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const TransactionDepositAndStake = withIcon(TransactionDepositAndStakeComponent);
